// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__V4zhE","signInText":"styles_signInText__16JW1"};